// Focus on the first OTP input field when the user presses enter on the member ID field
// This is not automatically handled by mui-one-time-password-input
export const handleFocusOtp = (event: React.KeyboardEvent<HTMLDivElement>) => {
  if (event.code === 'Enter') {
    event.preventDefault();
    const inputElements = document.getElementsByTagName('input');
    const array = [...inputElements];
    array.find((el) => el.autocomplete === 'one-time-code')?.focus();
  }
};
